/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для видео где угодно
   */
  app.BaseVideoView = app.View.extend({
    templateName: '',
    template: '',
    player: null,

    run: function (options) {
      if (options && options.templateName && _.isString(options.templateName)) {
        this.templateName = options.templateName;
      }
      if ($(this.templateName).length) {
        this.template = app.helpers.TemplateHelper.getTemplate(this.templateName);
      }
    },

    render: function (modelOrSrc, poster) {
      this.$el.html(this.template({
        modelOrSrc: modelOrSrc,
        poster: poster
      }));
      this.initPlayer();
    },
    /**
     * Отключение плеера, снятие всех обработчиков
     */
    destructPlayer: function () {
      // Проверяем наличие блока с видео
      var video = this.$('.video-js');
      if (video.length) {
        /**
         * Перестаем слушать события плеера перед удалением.
         */
        if (this.trackingPlayback) {
          clearInterval(this.trackingPlayback);
        }
        this.player.off('play', this.sendData.bind(this));
        this.player.off('pause', this.sendData.bind(this));
        this.player.off('ended', this.sendData.bind(this));
        videojs(video[0]).dispose();
      }
    },
    /**
     * Подключение плеера
     */
    initPlayer: function () {
      // Проверяем наличие блока с видео в отрендеренном блоке
      var video = this.$('.video-js');
      if (video.length) {
        // инициализируем video.js
        this.player = videojs(video[0]);
        this.player.ready(this.readyHandler.bind(this));
        this.player.on('error', this.errorHandler.bind(this));
        if (this.player.error()) {
          return this.errorHandler();
        }
        this.readyHandler();
        /**
         * По готовности слушаем события плеера для отправки в око.
         */
        this.player.on('play', this.sendData.bind(this));
        this.player.on('pause', this.sendData.bind(this));
        this.player.on('ended', this.sendData.bind(this));
      }
    },
    /**
     * Удаление view, отключаем все плагины, удаляем коллбеки
     */
    destruct: function () {
      this.destructPlayer();
    },
    sendData: function (e) {
      var sid,
        type = e.type;
      if (this.model && this.model.get('sid')) {
        sid = this.model.get('sid');
      }
      app.helpers.OkoHelper.push({
        'n': 'video',
        'action': type,
        'sid': sid
      });
      if (e.type === 'play') {
        this.sendTime(sid);
        this.trackingPlayback = setInterval(function () {
          this.sendTime(sid);
        }.bind(this), 10000);
      }
      if (e.type === 'pause') {
        if (this.trackingPlayback) {
          clearInterval(this.trackingPlayback);
        }
      }
    },
    errorHandler: function () {
    },
    readyHandler: function () {
    },
    /**
     * Отправка время видео в ОКО
     * @param sid
     */
    sendTime: function (sid) {
      var time = parseInt(this.player.currentTime(), 10);
      app.helpers.OkoHelper.push({
        'n': 'video',
        'time': time,
        'sid': sid
      });
    }

  });
})(jQuery);

}.call(window));
}.call(window));